'use strict';

var angularModule = angular.module('t2g.common.services.languageSwitch', [
  'gettext',
  require('t2g.common.data-access.user').name,
  require('t2g.common.services.notificationService').name,
  require('t2g.common.services.userSessionService').name,
]);

module.exports = angularModule;

angularModule.factory('languageSwitch', function(
  gettextCatalog,
  Notification,
  UserModel,
  UserSession,
  settings,
) {
  return {
    set: set,
    init: init,
  };

  function set(languageCode, doNotUpdateUser) {
    gettextCatalog.setCurrentLanguage(languageCode);

    if (!doNotUpdateUser) {
      var user = UserSession.get();
      var userUpdate = {
        _id: user._id,
        language: languageCode,
      };

      UserModel.update(userUpdate, function(error) {
        if (error) {
          Notification.addErrorMessage({ text: error });
        } else {
          Notification.addSuccessMessage(gettextCatalog.getString('User settings updated'));
        }
      });
    }

    return gettextCatalog
      .loadRemote('/i18n/' + languageCode + '.json?v=4.5.6')
      .then(function() {
        _.forEach(settings.availableLanguages, function(lang) {
          var i18nOverwrite = _.get(settings, 'i18nOverwrite.' + lang);
          if (i18nOverwrite) {
            gettextCatalog.setStrings(lang, i18nOverwrite);
          }
        });
        return true;
      });
  }

  function init() {
    var user = UserSession.get();

    // check for browser language
    if (user && user.language) {
      return set(user.language, true);
    } else {
      return set(settings.defaultLanguage, true);
    }
  }
});



// WEBPACK FOOTER //
// ./src/app/common/services/languageSwitch.js